import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@/config/api'

export const Navbar = (): JSX.Element => {
    const navigate = useNavigate()

    const handleGoToSettings = () => {
        navigate(ROUTES.STORE_SETTING)
    }

    const handleGoToDashboard = () => {
        navigate(ROUTES.DASHBOARD)
    }

    return (
        <div className="relative self-stretch w-full h-16 bg-[#efdfac] border-b-2 [border-bottom-style:solid] border-white">
            {/* Logo - 可點擊跳回 Dashboard */}
            <button
                onClick={handleGoToDashboard}
                className="absolute top-[9px] left-[34px] w-[30px] h-[42px] bg-[url(/vector-3.svg)] bg-[100%_100%] cursor-pointer hover:opacity-80 transition-opacity"
                title="返回首頁"
            >
                <img
                    className="absolute w-[36.79%] h-[26.20%] top-[23.52%] left-[31.27%]"
                    alt="Vector"
                    src="/vector-4.svg"
                />

                <img
                    className="absolute w-[42.29%] h-[20.02%] top-[49.64%] left-[28.86%]"
                    alt="Vector"
                    src="/vector-5.svg"
                />
            </button>

            {/* CALLLINK 文字 - 可點擊跳回 Dashboard */}
            <button
                onClick={handleGoToDashboard}
                className="absolute top-[calc(50.00%_-_16px)] left-[74px] cursor-pointer hover:opacity-80 transition-opacity"
                title="返回首頁"
            >
                <div className="[font-family:'Noto_Sans',Helvetica] font-black text-white text-base text-left tracking-[1.60px] leading-4 whitespace-nowrap">
                    CALLLINK
                </div>
            </button>

            {/* 智慧語音客服雲平台 文字 - 可點擊跳回 Dashboard */}
            <button
                onClick={handleGoToDashboard}
                className="absolute top-[calc(50.00%_+_1px)] left-[74px] cursor-pointer hover:opacity-80 transition-opacity"
                title="返回首頁"
            >
                <div className="[font-family:'Noto_Sans_TC',Helvetica] font-bold text-white text-[10px] text-left tracking-[1.00px] leading-4 whitespace-nowrap">
                    智慧語音客服雲平台
                </div>
            </button>

            {/* 店家設定按鈕 */}
            <button
                onClick={handleGoToSettings}
                className="absolute top-[calc(50.00%_-_32px)] right-[30px] w-16 h-16 aspect-[1] cursor-pointer hover:opacity-80 transition-opacity"
                title="店家設定"
            >
                <img
                    className="w-full h-full"
                    alt="User account"
                    src="/img/user-account.svg"
                />
            </button>
        </div>
    )
}
